import { AlertCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { IncomeType } from "shared/types";
import { cx } from "shared/utils";
import { parseDocStatus } from "views/applications-id-report/utils/parseDocStatus";

export const WarningRecommendation = ({
  type,
  status,
  rejectionReason,
  className,
  score,
  additionalData
}: {
  type?: IncomeType;
  status?: "Rejected" | "Warning" | "Accepted";
  rejectionReason?: string;
  className?: string;
  score?: number;
  additionalData?: {
    filename?: string;
  };
}) => {
  if (status === "Rejected" || status === "Warning") {
    const getUserFriendlyRejectionReason = (
      rejectionMessage?: string,
      filename?: string,
      score?: number
    ) => {
      if (
        rejectionMessage?.toLowerCase().includes("duplicate document") &&
        filename
      )
        return `Duplicate document of ${filename}`;

      if (rejectionMessage) return rejectionMessage;

      if (score !== undefined && parseDocStatus(score) === "Rejected")
        return "Low authenticity score";

      return "Document requires manual review";
    };

    const userFriendlyRejectionReason = getUserFriendlyRejectionReason(
      rejectionReason,
      additionalData?.filename,
      score
    );

    return (
      <div
        className={cx(
          "flex items-center gap-3 p-4 rounded-lg border border-alpha-100",
          status === "Rejected" ? "bg-danger-50" : "bg-warning-50",
          className
        )}
      >
        <HugeiconsIcon
          icon={AlertCircleIcon}
          size={20}
          className={cx(
            "shrink-0",
            status === "Rejected" ? "text-danger-500" : "text-warning-500"
          )}
        />
        {type === IncomeType.OfferLetter ? (
          <p className="text-sm text-content-1000 font-medium">
            {userFriendlyRejectionReason}
          </p>
        ) : (
          <p className="text-sm text-content-1000 font-medium">
            {status === "Warning" &&
              "We recommend manually reviewing the document as suspicious signals were found"}

            {status === "Rejected" &&
              `Uploaded document rejected: ${userFriendlyRejectionReason}`}
          </p>
        )}
      </div>
    );
  }

  return null;
};
